var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDays1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 48",
    style: {
      enableBackground: "new 0 0 64 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.0637207,
    y1: 24,
    x2: 63.9363,
    y2: 24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A77BAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2383,
    style: {
      stopColor: "#9471A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7454,
    style: {
      stopColor: "#735F9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#65589B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.9,11.7V9.3c0-2-1.6-3.6-3.6-3.6h-6.8V0.1h-3v5.7H12.7V0.1h-3v5.7H3.6c-2,0-3.6,1.6-3.6,3.6V15h0v28.9 c0,2.2,1.8,4,4.1,4h55.7c2.2,0,4.1-1.8,4.1-4L63.9,11.7L63.9,11.7z M3.6,8.8h6.1v1.4h3V8.8h37.8v1.4h3V8.8h6.8 c0.3,0,0.6,0.2,0.6,0.6v2.4h0V12H3.1v-0.3H3.1V9.3C3.1,9,3.3,8.8,3.6,8.8z M3.1,23.7h10.7V32H3.1V23.7z M16.9,23.7h12.8V32H16.9 V23.7z M29.7,15v5.7H16.9V15H29.7z M45.6,15v5.7H32.7V15H45.6z M29.7,35v10H16.9V35H29.7z M32.7,35h12.8v10H32.7V35z M32.7,32v-8.3 h12.8V32H32.7z M48.6,23.7h12.4V32H48.6V23.7z M48.6,20.7V15h12.4v5.7H48.6z M13.9,15v5.7H3.1V15H13.9z M3.1,43.9V35h10.7v10H4.2 C3.6,44.9,3.1,44.5,3.1,43.9z M59.9,44.9H48.6V35h12.4v8.9C60.9,44.5,60.4,44.9,59.9,44.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDays1);
export default __webpack_public_path__ + "static/media/icon_days1.433f128112c8a7dc77cd80318e4b2b92.svg";
export { ForwardRef as ReactComponent };